export default __webpack_public_path__ + "static/altasaventuras-6e85d8413122fd0495e2d0a7916453c4.png";